<div class="card outer-card">
  <div class="row align-items-center header-row">
    <div class="col-md-3 text-center text-md-start">
      <img src="assets/Images/GaDOE-Logo-Color-188X100.png" alt="GaDOE Logo" />
    </div>

    <div class="col-md-9 text-center text-md-end">
      <div class="social-icons mb-2">
        <a href="https://www.facebook.com/georgiadeptofed" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <fa-icon [icon]="faFacebook" class="social-icon"></fa-icon>
        </a>

        <a href="https://twitter.com/georgiadeptofed" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
          <fa-icon [icon]="faTwitter" class="social-icon"></fa-icon>
        </a>

        <a href="http://instagram.com/georgiadeptofed" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <fa-icon [icon]="faInstagram" class="social-icon"></fa-icon>
        </a>

        <a href="http://www.youtube.com/user/GaDOEmedia/" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
          <fa-icon [icon]="faYoutube" class="social-icon"></fa-icon>
        </a>

        <a href="http://www.pinterest.com/georgiadoe/" target="_blank" rel="noopener noreferrer" aria-label="Pinterest">
          <fa-icon [icon]="faPinterest" class="social-icon"></fa-icon>
        </a>

        <a href="https://gadoe.org/External-Affairs-and-Policy/communications/_layouts/15/listfeed.aspx?List=%7B3D49120A%2DA526%2D46B9%2DA228%2D6A9C31823D63%7D" target="_blank" rel="noopener noreferrer" aria-label="RSS">
          <fa-icon [icon]="faRss" class="social-icon"></fa-icon>
        </a>
      </div>

      <p class="superintendent-link mb-0">
        <a href="https://gadoe.org/Pages/superintendent.aspx" target="_blank" rel="noopener noreferrer">
          <i><b>Richard Woods</b>, Georgia's School Superintendent</i>
        </a>
      </p>
    </div>
  </div>

<div class="green-divider breadcrumb-bar">
  <div class="breadcrumb-content">
    <a
      href="https://gadoe.org/"
      class="breadcrumb-home-link"
      aria-label="Home">
      <img src="assets/Images/Black Home.png" alt="" class="breadcrumb-home-icon" />
      <span class="breadcrumb-home-dash">-</span>
      <span>Home</span>
    </a>
    <span class="breadcrumb-separator">•</span>
    <a
      href="https://gadoe.org/External-Affairs-and-Policy/Policy/Pages/Special-Needs-Scholarship-Program.aspx"
      class="breadcrumb-link">
      Special Needs Scholarship Program
    </a>
  </div>
</div>

  <div class="row justify-content-center">
    <div class="col-xl-11 col-lg-11 col-md-12">
      <app-awardletter
        *ngIf="showChildform"
        (cancel)="cancelHandler()"
        [calcSearchModel]="calcSearch">
      </app-awardletter>

      <div class="eligibility-panel" *ngIf="!showChildform">
        <div class="eligibility-title">Eligibility Calculator</div>

        <div class="eligibility-loader-card" *ngIf="isInitialLoading">
          <div class="eligibility-loader-spinner" aria-hidden="true"></div>
          <div class="eligibility-loader-title">Loading calculator information...</div>
          <div class="eligibility-loader-text">Please wait while we load the current school year, systems, and schools.</div>
        </div>

        <ng-container *ngIf="!isInitialLoading">
        <div class="eligibility-note-box">
          <div class="eligibility-note-text">
            <strong>Please Note:</strong> {{ CalcConfig?.message }}
          </div>

          <div class="eligibility-required-text" *ngIf="isCalculatorOpen">
            <span class="required-star">*</span>
            Fields marked with an asterisk (*) are required.
          </div>
        </div>

        <div class="eligibility-form-shell" *ngIf="isCalculatorOpen">
          <form [formGroup]="calSearchForm" (ngSubmit)="submitSearch()">
            <div class="eligibility-form-card">
            <div class="eligibility-search-overlay" *ngIf="isSearching">
              <div class="eligibility-loader-spinner eligibility-loader-spinner-small" aria-hidden="true"></div>
              <div class="eligibility-search-text">Searching student eligibility...</div>
            </div>
            <div class="eligibility-row school-year-row">
              <div class="eligibility-label">School Year:</div>

              <div class="eligibility-field">
                <span class="readonly-value">
                  {{ CalcConfig?.currentYear }}
                </span>
              </div>
            </div>

              <div class="section-divider">Prior School Information</div>

              <div class="eligibility-row">
                <div class="eligibility-label required-label">Last System Attended:</div>
                <div class="eligibility-field">
                  <kendo-combobox
                    name="system"
                    formControlName="system"
                    [data]="filteredSystems"
                    [textField]="'text'"
                    [valueField]="'value'"
                    [filterable]="true"
                    [suggest]="false"
                    [allowCustom]="false"
                    placeholder="Select System"
                    (filterChange)="handleSystemFilter($event)"
                    (valueChange)="OnSystemChange($event)"
                    [valuePrimitive]="true"
                    [disabled]="isSearching"
                    tabindex="2">
                  </kendo-combobox>

                  <div *ngIf="f['system'].touched && f['system'].hasError('required')" class="text-danger field-error">
                    Please select system
                  </div>
                </div>
              </div>

              <div class="eligibility-row">
                <div class="eligibility-label required-label">Last School Attended:</div>
                <div class="eligibility-field">
                  <kendo-combobox
                    name="school"
                    formControlName="school"
                    [data]="filteredSchools"
                    [textField]="'text'"
                    [valueField]="'value'"
                    [filterable]="true"
                    [suggest]="false"
                    [allowCustom]="false"
                    placeholder="Select School"
                    (filterChange)="handleSchoolFilter($event)"
                    [valuePrimitive]="true"
                    [disabled]="isSearching || isSchoolLoading || !f['system'].value"
                    tabindex="3">
                  </kendo-combobox>

                  <div *ngIf="isSchoolLoading" class="field-hint">
                    Loading schools...
                  </div>

                  <div *ngIf="f['school'].touched && f['school'].hasError('required')" class="text-danger field-error">
                    Please select school
                  </div>
                </div>
              </div>

              <div class="section-divider">Student Details</div>

              <div class="eligibility-row compact-row">
                <div class="eligibility-label required-label">First Name:</div>
                <div class="eligibility-field small-input-field">
                  <input
                    class="form-control eligibility-input"
                    name="firstName"
                    type="text"
                    formControlName="firstName"
                    maxlength="50"
                    [readonly]="isSearching"
                    tabindex="4" />

                  <div *ngIf="f['firstName'].touched && f['firstName'].hasError('required')" class="text-danger field-error">
                    Please enter First Name
                  </div>
                  <div *ngIf="f['firstName'].touched && f['firstName'].hasError('pattern')" class="text-danger field-error">
                    First Name may contain only alphabetic characters and name punctuation
                  </div>
                </div>
              </div>

              <div class="eligibility-row compact-row">
                <div class="eligibility-label required-label">Last Name:</div>
                <div class="eligibility-field small-input-field">
                  <input
                    class="form-control eligibility-input"
                    name="lastName"
                    type="text"
                    formControlName="lastName"
                    maxlength="50"
                    [readonly]="isSearching"
                    tabindex="5" />

                  <div *ngIf="f['lastName'].touched && f['lastName'].hasError('required')" class="text-danger field-error">
                    Please enter Last Name
                  </div>
                  <div *ngIf="f['lastName'].touched && f['lastName'].hasError('pattern')" class="text-danger field-error">
                    Last Name may contain only alphabetic characters and name punctuation
                  </div>
                </div>
              </div>

              <div class="eligibility-row compact-row dob-row">
                <div class="eligibility-label required-label">Date of Birth:</div>
                <div class="eligibility-field dob-field">
                  <kendo-datepicker
                    [format]="'MM/dd/yyyy'"
                    [formatPlaceholder]="{ year: 'yyyy', month: 'mm', day: 'dd' }"
                    [popupSettings]="datePickerPopupSettings"
                    placeholder="mm/dd/yyyy"
                    name="dateofBirth"
                    formControlName="dateofBirth"
                    [disabled]="isSearching"
                    tabindex="6">
                  </kendo-datepicker>

                  <div *ngIf="f['dateofBirth'].touched && f['dateofBirth'].hasError('required')" class="text-danger field-error">
                    Please enter Date of Birth
                  </div>
                  <div *ngIf="f['dateofBirth'].touched && f['dateofBirth'].hasError('futureDate')" class="text-danger field-error">
                    Date of Birth cannot be a future date
                  </div>
                  <div *ngIf="f['dateofBirth'].touched && f['dateofBirth'].hasError('invalidDate')" class="text-danger field-error">
                    Please enter Date of Birth in MM/DD/YYYY format
                  </div>
                </div>
              </div>

              <div *ngIf="noMatchFound" class="alert alert-warning text-start mt-2">
                <p class="mb-2">{{ noMatchMessage }}</p>
                <a [href]="inquiryFormUrl" target="_blank" rel="noopener noreferrer">
                  Georgia Special Needs Scholarship Parent Inquiry Form
                </a>
              </div>

              <div class="eligibility-button-row">
                <button
                  type="submit"
                  class="determine-btn"
                  tabindex="7"
                  [disabled]="calSearchForm.invalid || isSearching || isInitialLoading">
                  {{ isSearching ? 'Searching...' : 'Determine Student Eligibility' }}
                </button>

                <button
                  type="button"
                  class="clear-btn"
                  tabindex="8"
                  [disabled]="isSearching || isInitialLoading"
                  (click)="clearClick()">
                  Clear
                </button>
              </div>
            </div>
          </form>
        </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
